<template>	   
	<v-container>
	 	<v-card>
	 	 	<v-card-title primary-title>
	 	 		<h3 class="display-1">Rutinas de descarga</h3>
	 	 	</v-card-title>
	 	 	<v-card-text>
	 	 		<v-text-field
	 	 		  name="search" solo v-model="table.search"
	 	 		  label="Buscar" append-icon="fa fa-search"
	 	 		  id="id"
	 	 		></v-text-field>
				<v-progress-linear :height="5" :active="table.loading" indeterminate></v-progress-linear>
	 	 	 	<v-data-table
	 	 	 	   :headers="table.headers"
	 	 	 	   :items="table.items"
	 	 	 	   :search="table.search"
	 	 	 	   class="elevation-1" v-model="selected"
	 	 	 	   item-key="id"
	 	 	 	 >
	 	 	 	   	<template v-slot:item.actions="props">
	 	
	 	 	 	   		<td>
	 	 	 	   			<v-btn text color="warning" small fab @click="edit(props.item)"><v-icon>fa fa-pen</v-icon></v-btn>
	 	 	 	   		</td>
	 	 	 	   	</template>
	 	 	 	 </v-data-table> 
	 	 	</v-card-text>
	 	 	<v-card-actions>
	 	 	 	<v-btn color="success" @click="create()">Agregar nuevo rutina de descarga</v-btn> 
	 	 	</v-card-actions>
	 	</v-card>
	 	<v-dialog
	 	  v-model="modalForm.active"
	 	  scrollable 
	 	  :overlay="false" 
	 	  max-width="900px"
	 	  transition="dialog-transition"
	 	>
	 	  	<v-card>
	 	  	 	<v-card-title primary-title>
	 	  	 	  <h4 class="headline">Registrar rutina de descarga</h4>
	 	  	 	</v-card-title>
	 	  	 	<v-card-text>
	 	  	 	 	<v-autocomplete
	 	  	 	 	  :items="selects.datasets"
	 	  	 	 	  item-value="value"
	 	  	 	 	  item-text="label"
	 	  	 	 	  v-model="modalForm.data.id_task"
	 	  	 	 	  label="Dataset ejecutable"
	 	  	 	 	>
	 	  	 	 		<template v-slot:item="props">
								<span class="body-2">{{props.item.label}}
								<br>
								<span class="caption"><strong>Tipo:</strong>{{props.item.type}}</span>
								</span>
	 	  	 	 		</template>
	 	  	 	 	</v-autocomplete>
						<v-autocomplete
	 	  	 	 	  :items="['Anual', 'Mensual', 'Semanal', 'Diario']"
	 	  	 	 	  v-model="modalForm.data.frecuency"
	 	  	 	 	  label="Frecuencia"
	 	  	 	 	>
	 	  	 	 	</v-autocomplete>
	 	  	 	 	<v-text-field
	 	  	 	 	  v-model="modalForm.data.step"
	 	  	 	 	  label="Intervalos"
	 	  	 	 	  type="number"
	 	  	 	 	></v-text-field>
	 	  	 	 	<v-autocomplete
	 	  	 	 	  :items="[-1, 0, 1, 2]"
	 	  	 	 	  v-model="modalForm.data.priority"
	 	  	 	 	  label="Prioridad"
	 	  	 	 	></v-autocomplete>
	 	  	 	</v-card-text>
	 	  	 	<v-card-actions>
	 	  	 		<v-btn color="success" v-if="modalForm.type == 'created'" @click="store()">Guardar</v-btn>
	 	  	 		<v-btn color="success" v-if="modalForm.type == 'edit'" @click="update()">Actualizar</v-btn>
	 	  	 		<v-btn color="warning" @click="closeDialog()">Cancelar</v-btn>
	 	  	 	</v-card-actions>
	 	  	</v-card>
	 	</v-dialog>
	 	<v-snackbar
	 	  v-model="alert.active"
	 	>
	 	 {{ alert.message }}
	 	  <v-btn text :color="alert.color" @click.native="alert.active = false">Close</v-btn>
	 	</v-snackbar>
	</v-container>
</template>
<script>
	export default{
		created() {

		},
		mounted(){
			this.getData();
			this.getDataset();
		},
		props: [
			'auth'
		],
		data(){
			return {
				createCategory: '',
				editCategory: '',
				baseRoute: process.env.VUE_APP_URL + 'api/gis/cron/proccess',
				table: {
					items: [],
					headers: [],
					loading: true,
					search: ''
				},
				modalForm: {
					active: false,
					type:'',
					data: {}
				},
				modalForm: {
					active: false,
					data: {}
				},
				alert: {
					active: false,
					message: "",
					color: "success"
				},
				selects: [],
				selected: [],
				response: ''
			}
		},
		methods: {
			getDataset(){
				axios.get(process.env.VUE_APP_URL + 'api/gis/dataRaw/getSelectTask').then((res) => {
					this.selects.datasets = res.data
				}).catch((error) => {
					this.alert.active = true
					this.alert.message = 'Hubó un error interno en el servidor contacte con el desarrollador'
					this.alert.color = "error";
				})
			},	
			getData(){
				axios.get(this.baseRoute + '?type=download' ).then((res) => {
					if(res.data == "Error"){
						this.alert.active = true;
						this.alert.message = "Impsoble traer los datos";
						this.alert.color = "error";
					}else{
						this.table.items = res.data.items;
						this.table.headers = res.data.headers;
					}
					this.table.loading = false;

				}).catch((error) => {
					this.table.loading = false;
					this.alert.active = true;
					this.alert.message = "Hubó un error interno en el servidor contacte con el desarrollador";
					this.alert.color = "error";
				});
			},
			create(){
				this.modalForm.active = true;
				this.modalForm.type = 'created';
				this.modalForm.data = {
					id_task: '',
					type: 'download',
					frecuency: '',
					priority: '',
				};
			},
			store(){
				axios.post(this.baseRoute + '/store', this.modalForm.data).then((res) => {
					if(res.data != "Exito"){
						this.alert.active = true;
						this.alert.message = "Los datos suministrados estan incompletos o no son validos";
						this.alert.color = "error";
					}else{
						this.alert.active = true;
						this.alert.message = "Creado exitosamente";
						this.alert.color = "success";
						this.actualiceData();
					}
				}).catch((error) => {
					this.alert.active = true;
					this.alert.message = "Hubó un error interno en el servidor contacte con el desarrollador";
					this.alert.color = "error";
				});
			},
			edit(item){
				this.modalForm.type = 'edit';
				this.modalForm.active = true;
				this.modalForm.data = item;
			},
			update(){
				axios.put(this.baseRoute + '/update', this.modalForm.data).then((res) => {
					if(res.data != "Exito"){
						this.alert.active = true;
						this.alert.message = "Los datos suministrados estan incompletos o no son validos";
						this.alert.color = "error";
					}else{
						this.alert.active = true;
						this.alert.message = "Actualizado correctamente";
						this.alert.color = "success";					
						this.actualiceData();

					}
				}).catch((error) => {
					this.alert.active = true;
					this.alert.message = "Hubó un error interno en el servidor contacte con el desarrollador";
					this.alert.color = "error";
				});
			},
			closeDialog(){
				this.modalForm.type = '';
				this.modalForm.active = false;
				this.modalForm.data = {};
			},
			actualiceData(){
				this.getData();
				this.modalForm.active = false;
			}
		},
		watch: {

		},
		computed: {

		},
	}
</script>